export const NAMESPACE = 'session'
